import { useDataChange } from 'Simple/Data.js'

export function useOnSubmit(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onSubmit(args) {
    // reset hack
    change(next => {
      next.comms.auto_uploaded_attachments = []
      next.comms.message = ''
      next.comms.tags = []
    })
  }
}

export function useOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      next.comms.message_composes[value.thread_id] = value
    })
  }
}

export function useOnThreadIdsHackChange(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'thread_ids_hack',
    viewPath: props.viewPath,
  })

  return function onThreadIdsHackChange(value) {
    change(value)
  }
}
